import { render, staticRenderFns } from "./solutionHelpList.vue?vue&type=template&id=0c8fe737&scoped=true"
import script from "./solutionHelpList.vue?vue&type=script&lang=js"
export * from "./solutionHelpList.vue?vue&type=script&lang=js"
import style0 from "./solutionHelpList.vue?vue&type=style&index=0&id=0c8fe737&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8fe737",
  null
  
)

export default component.exports